import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SvgIcon, SvgIconComponent } from '@web/shared/ui';

@Component({
  selector: 'app-brand-social-media-icon',
  imports: [SvgIconComponent],
  templateUrl: './brand-social-media-icon.component.html',
  styleUrl: './brand-social-media-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandSocialMediaIconComponent {
  public readonly icon = input.required<SvgIcon>();
}
